// Light-weight validator for the three on-chain address shapes we render
// links to in the UI. Not a full bech32 checksum — just structural so the
// search bar knows to surface an "Address" suggestion.

const BECH32 = /^(bc1|tb1)[02-9ac-hj-np-z]{8,87}$/i
const LEGACY = /^[13][a-km-zA-HJ-NP-Z1-9]{25,34}$/
const TAPROOT = /^bc1p[02-9ac-hj-np-z]{58,}$/i

export default function isBtcAddress(value: string): boolean {
	if (!value) return false
	const v = value.trim()
	return TAPROOT.test(v) || BECH32.test(v) || LEGACY.test(v)
}
